import api from "./apiHelper";
import { getUserAuthObj } from "../utils/auth";

export const postGlobal = (payload) => {
  return api.post(`/global/`, payload);
};

export const getGlobal = () => {
  return api.get(`/global/`);
};
